import React from 'react'
import { Field } from 'redux-form'
import { IconButton, Grid } from '@material-ui/core'
import { AddRounded } from '@material-ui/icons'
import { required } from 'services/validations'

import { Input, SelectInput } from 'components'
import { BUS_BRANDS } from "constants/arrays";

// TODO: Check if driver exist before adding
export const CreateBusFormBase = ({ classes, handleSubmit }) => (
  <Grid
    container
    spacing={16}
    component='form'
    className={classes.container}
    alignItems='center'
  >

    <Grid item>
      <Field
        required
        name='brand'
        label='Виробник'
        margin='none'
        component={SelectInput}
      >
        <option value='' />
        {BUS_BRANDS.map(brand => (
          <option key={brand} value={brand}>
            {brand}
          </option>
        ))}
      </Field>
    </Grid>

    <Grid item xs>
      <Field
        fullWidth
        name='label'
        label='Назва'
        margin='none'
        validate={required}
        component={Input}
      />
    </Grid>

    <Grid item>
      <Field
        name='qty'
        type='number'
        label='кть'
        margin='none'
        validate={required}
        className={classes.qty}
        component={Input}
      />
    </Grid>

    <Grid item>
      <IconButton onClick={handleSubmit}>
        <AddRounded fontSize='small' />
      </IconButton>
    </Grid>

  </Grid>
)



// WEBPACK FOOTER //
// ./src/components/Buses/components/CreateBusForm/CreateBusForm.js